import { Diagnosis, DiagnosisQuery } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { medicalDataTranslationKeys } from '../../../translations';
import { SidePanelLoader } from '../../SidePanelLoader';

type DiagnosisSidePanelListLoaderRenderProps = {
   diagnosis: Diagnosis[];
};

type DiagnosisSidePanelListLoaderProps = {
   readonly patientId: number;
   readonly children: (props: DiagnosisSidePanelListLoaderRenderProps) => JSX.Element;
};

export const DiagnosisSidePanelListLoader = (props: DiagnosisSidePanelListLoaderProps): JSX.Element => {
   const { data: diagnosis, loading: diagnosisLoading, error: diagnosisError } = useCqrsSearch<Diagnosis>(() => {
      const query = new DiagnosisQuery();
      query.patientId = Slot.of(props.patientId ?? null);
      return query;
   }, paginations.all<Diagnosis>().orderedBy('creationDate', Direction.DESCENDING));

   if (diagnosisLoading) {
      return <SidePanelLoader />;
   }

   if (diagnosisError) {
      return (
         <Message
            testId={'failedToFetchDiagnosis'}
            label={medicalDataTranslationKeys.failedToFetchMedicalInformation}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      diagnosis: diagnosis,
   });
};
